/*----------------------------------
- DOMAINS MENU CHIP
----------------------------------*/

import type { LandingHeaderNavPanelItem } from '@/client/catalogs/landing/pageContent';
import { readMenuItemCount } from './menuShared';

/*----------------------------------
- TYPES
----------------------------------*/

type DomainsMenuChipProps = {
    item: LandingHeaderNavPanelItem;
    fallbackHref: string;
    /** TLD chips split the leading dot from the extension so it can be dimmed (`.msm-dot`). */
    isTld?: boolean;
    onClick?: () => void;
};

/*----------------------------------
- COMPONENT
----------------------------------*/

/**
 * One ending or one sector in the phone sheet: the system's filter chip look (`ud-chip-filter`, the count in its
 * `em`) on an anchor. Not the kit `FilterChip`, which is a pressed-state button: this chip is a link to a page. The
 * phone's shape alone, since a wrapping chip is the only way ten short labels fit a phone column.
 */
export default function DomainsMenuChip({ item, fallbackHref, isTld = false, onClick }: DomainsMenuChipProps) {
    const href = item.href || fallbackHref;
    const count = readMenuItemCount(item);
    const label = isTld ? item.label.replace(/^\./, '') : item.label;

    return (
        <a href={href} onClick={onClick} aria-label={isTld ? `Browse .${label} domains` : undefined} class="ud-chip-filter">
            <span>
                {isTld ? <i class="msm-dot">.</i> : null}
                {label}
            </span>
            {count ? <em>{count}</em> : null}
        </a>
    );
}
